export default __webpack_public_path__ + "static/media/bgsecondary.c043e118.jpg";